import { Injectable } from "@angular/core";

import { AuthenticationService } from "../authentication/authentication.service";
import { ApiGatewayService } from "../../common/api-gateway/api-gateway.service";

@Injectable()
export class SkipWizardService {
	constructor(
		private apiGatewayService: ApiGatewayService,
		private auth: AuthenticationService
	) { }

	public getHideWizardFromCurrentUser() {
		const user = this.auth.getCurrentUser();
		return !!user ? user.hideWizard : false;
	}

	public async processHideWizard(hideWizard: boolean) {
		await this.apiGatewayService.updateHideWizard(hideWizard);
		const user = this.auth.getCurrentUser();
		// user can return undefined, but should not. saveCurrentUser can not pass undefined as type
		if (!!user) {
			user.hideWizard = hideWizard;
			this.auth.saveCurrentUser(user);
		}
	}
}
